var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6C10.125 4.3425 8.7825 3 7.125 3C5.4675 3 4.125 4.3425 4.125 6C4.125 7.6575 5.4675 9 7.125 9C8.7825 9 10.125 7.6575 10.125 6ZM8.625 6C8.625 6.825 7.95 7.5 7.125 7.5C6.3 7.5 5.625 6.825 5.625 6C5.625 5.175 6.3 4.5 7.125 4.5C7.95 4.5 8.625 5.175 8.625 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 13.5V15H13.125V13.5C13.125 11.505 9.1275 10.5 7.125 10.5C5.1225 10.5 1.125 11.505 1.125 13.5ZM2.625 13.5C2.775 12.9675 5.1 12 7.125 12C9.1425 12 11.4525 12.96 11.625 13.5H2.625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.5H12.375V9H16.875V7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRemove);
export default __webpack_public_path__ + "static/media/person-remove.35b67e31.svg";
export { ForwardRef as ReactComponent };